/**
 * Created by rhinov15 on 02/11/2016.
 *
 * Node taking care of floor area display. The floor in itsef has nothing to display
 */

import { EntityNode } from "./EntityNode";
import { AreaNode } from "../Nodes/AreaNode";
import { Area, ComponentConstants, Entity, Event, Events, eventsManager, FloorCoatingArea } from "@rhinov/savane-js";

declare var cc: any;

export class FloorNode extends EntityNode {

     //@const
    _INSIDE_COLOR = cc.color(120, 120, 230, 125);
    //@const
    _INSIDE_HOVERED_COLOR = cc.color(160, 160, 255, 125);
    //@const
    _INSIDE_SELECTED_COLOR = cc.color(230, 120, 230, 125);
    //@const
    _BORDER_COLOR = new cc.color(120, 120, 120, 255);
    areaNodes: AreaNode[];
    _currentEditedArea: number;

    constructor (entity: Entity) {
        super(entity);
        // Store floor savane entity for further use
        this.entity = entity;
        // Area node array to store all area nodes of the floor
        this.areaNodes = [];
        // Get all areas of the floor
        var areas: (Area | FloorCoatingArea)[] = [];
        areas = areas.concat(entity.getComponents(ComponentConstants.ComponentType.Area) as Area[]);
        areas = areas.concat(entity.getComponents(ComponentConstants.ComponentType.FloorCoatingArea) as FloorCoatingArea[]);

        // Parse them all and create area nodes for each of them and add them as children of current node
        for (var i = 0; i < areas.length; i++) {
            this.createArea(areas[i] as FloorCoatingArea);
        }

        this._closed = true;

        this._currentEditedArea = -1;
    }

    rebuildAreas() {
        for (var i = 0; i < this.areaNodes.length; ++i) {
            this.areaNodes[i].removeFromParent();
        }
        this.areaNodes = [];
        // Get all areas of the floor
        var areas: (Area | FloorCoatingArea)[] = [];
        areas = areas.concat(this.entity.getComponents(ComponentConstants.ComponentType.Area));
        areas = areas.concat(this.entity.getComponents(ComponentConstants.ComponentType.FloorCoatingArea));

        // Parse them all and create area nodes for each of them and add them as children of current node
        for (var i = 0; i < areas.length; i++) {
            this.createArea(areas[i] as FloorCoatingArea);
        }
        this._currentEditedArea = -1;
    }

    getInsideColor(area: FloorCoatingArea) {
        if (area.componentType === ComponentConstants.ComponentType.FloorCoatingArea) {
            var color;
            if (area.colors[area.colorIndex - 1] !== undefined) {
                color = new cc.color(area.colors[area.colorIndex - 1].realColor);
                color.a = 125;
                return color;
            }
            else {
                if (area.color !== null) {
                    color = new cc.color(area.color.color);
                    color.a = 125;
                    return color;
                }
                else {
                    color = new cc.color(area.colors[0].color.color);
                    color.a = 125;
                    return color;
                }
            }
        }
        return this._INSIDE_COLOR;
    }

    // Remove the currently edited area node from the floor node
    removeArea () {
        // Only if an area is edited
        if (this._currentEditedArea !== -1) {
            // Remove the area node from its parent (this node)
            this.areaNodes[this._currentEditedArea].removeFromParent();
            // Remove the node from the area nodes to display
            this.areaNodes.splice(this._currentEditedArea, 1);
            // NO currently edited area anymore
            this._currentEditedArea = -1;
        }
    }

    // Create a new area to be added to the current node
    createArea (area: FloorCoatingArea) {
        // Create the area node
        var insideColor = this.getInsideColor(area);
        var areaNode = new AreaNode(area, area.vertices, insideColor, this._BORDER_COLOR);

        // Add the area node to the current node as child
        this.areaNodes.push(areaNode);
        this.addChild(areaNode);
    }

    // Set the currently edited area to be closed (a real polygon)
    setClosed (value: boolean) {
        this._closed = value;
        // If there is a currently edited area, this area is closed
        if (this._currentEditedArea !== -1) {
            this.areaNodes[this._currentEditedArea].setClosed(value);
        }
    }

    // An area is selected, display it as selected and display its points
    setSelected (value: boolean) {
        super.setSelected(value);
        // Only if an area is being edited
        if (this._currentEditedArea !== -1) {
            var insideColor = this.getInsideColor(this.areaNodes[this._currentEditedArea].component);
            this.areaNodes[this._currentEditedArea].setColor(value ? this._INSIDE_SELECTED_COLOR : insideColor);
            this.areaNodes[this._currentEditedArea].setPointVisible(value);
            if (!value) {
                return;
            }
        }
    }

    setPointSelected(value: number) {
        if (this._currentEditedArea !== -1) {
            this.areaNodes[this._currentEditedArea].setPointSelected(value);
        }
    }

    setLineSelected(value: number) {
        if (this._currentEditedArea !== -1) {
            this.areaNodes[this._currentEditedArea].setLineSelected(value);
        }
    }

    // And area is hovered
    setHovered (value: boolean) {
        super.setHovered(value);
        // Is an area is edited the the area color
        if (this._currentEditedArea !== -1) {
            var insideColor = this.getInsideColor(this.areaNodes[this._currentEditedArea].component);
            this.areaNodes[this._currentEditedArea].setColor(value ? this._INSIDE_HOVERED_COLOR : insideColor);
        }
    }

    // Update all area nodes
    update (dt: number) {
        super.update(dt);
        // Parse them all and draw them all
        for (var i = 0; i < this.areaNodes.length; i++) {
            this.areaNodes[i].draw();
        }
    }

    // Class creation
    onEnter () {
        super.onEnter();

        // Create all listeners for area creation, destruction, edition

        // Listener for area destruction
        this.removeAreaListener = eventsManager.instance.addListener(Events.COMPONENT_REMOVED,
            (event: Event) => {
                if (event.userData !== null && event.userData !== undefined) {
                    var component = event.userData.component;
                    var parent = event.userData.from;
                    var entity = event.userData._entity;

                    if (parent !== null && parent !== undefined && parent.id === this.savaneEntity.id &&
                        component !== null && component !== undefined) {
                        switch (component.componentType) {
                            case ComponentConstants.ComponentType.Area:
                            case ComponentConstants.ComponentType.FloorCoatingArea:
                                this.rebuildAreas();
                                break;
                        }
                    }

                    //fixme : 2 use case?
                    if (entity !== null && entity !== undefined && entity.id === this.savaneEntity.id) {
                        switch (event.userData.componentType) {
                            case ComponentConstants.ComponentType.Area:
                            case ComponentConstants.ComponentType.FloorCoatingArea:
                                this.rebuildAreas();
                            break;
                        }
                    }
                }
            });

        // Listener for area creation
        this.addAreaListener = eventsManager.instance.addListener(Events.COMPONENT_ADDED,
            (event: Event) => {
                var component = event.userData;
                if (component !== null && component !== undefined &&
                    component.entity !== null && component.entity !== undefined &&
                    component.entity.id === this.savaneEntity.id) {
                    switch (component.componentType) {
                        case ComponentConstants.ComponentType.Area:
                        case ComponentConstants.ComponentType.FloorCoatingArea:
                            this.rebuildAreas();
                            break;
                    }
                }
            });

        // Listener for area edition
        this.editedAreaListener = eventsManager.instance.addListener(Events.COMPONENT_EDITED,
            (event: Event) => {
                var component = event.userData;
                if (component !== null && component !== undefined && this._currentEditedArea !== -1) {
                    if (component._entity !== null && component._entity !== undefined &&
                        component._entity.id === this.savaneEntity.id) {
                        switch (component.componentType) {
                            case ComponentConstants.ComponentType.Area:
                            case ComponentConstants.ComponentType.FloorCoatingArea:
                                this.areaNodes[this._currentEditedArea].setVertices(component.vertices);
                                break;
                        }
                    }
                }
            });

    }

    // Class destruction, remove all listeners
    onExit () {
        super.onExit();
        eventsManager.instance.removeListener(this.addAreaListener);
        eventsManager.instance.removeListener(this.removeAreaListener);
        eventsManager.instance.removeListener(this.editedAreaListener);
    }
}
